module.exports = __webpack_public_path__ + "img/lock_white_24dp.a17ac854.png";